import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";

const ForgotPasswordOTP = ({ handleCloseOTPModal, email }) => {
  const [otp, setOtp] = useState("");
  const handleOTPSubmit = () => {
    const sendOTP = async () => {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/verify-forget-password-otp`, {
        method: "PUT",
        //add token to headers
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, otp }),
      });
      const data = await response.json();
      if (data.code === 400) {
        toast.error("OTP is incorrect");
      } else if (data.code === 200) {
        toast.success("OTP is verified!");
        window.location.href = "/dashboard/card_generation";
      }
    };
    sendOTP();
  };
  return (
    <div
      className={`fixed inset-0 z-50 $
     flex items-center justify-center" 
    backdrop-blur-[3px] bg-black bg-opacity-20`}
    >
      <div className="flex flex-col items-center justify-center bg-white rounded-md sm:p-12 p-8 mx-auto">
        <div className="flex flex-row-reverse items-center justify-between w-full relative sm:bottom-10 bottom-5">
          <AiOutlineClose
            className="text-primaryGreen cursor-pointer relative sm:left-9 left-5"
            size={30}
            onClick={handleCloseOTPModal}
          />
        </div>
        <h3 className="text-3xl text-center mb-5">
          Enter One Time Password (OTP)
        </h3>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          required
          inputStyle={{
            border: "2px solid #F59930",
            borderRadius: 5,
            width: 40,
            height: 50,
            margin: 3,
            textAlign: "center",
            fontSize: 20,
            fontWeight: "bold",
            color: "#F66",
          }}
          renderSeparator={<span style={{ color: "#F66" }}>-</span>}
          renderInput={(props) => <input {...props} />}
          shouldAutoFocus
          placeholder="XXXXXX"
        />
        <div className="flex items-center justify-center gap-2">
          <button
            className="py-3 px-10 mt-5 border-2 border-[#F66] text-[#F66] duration-150 ease-linear rounded-md hover:bg-[#F66] hover:text-white"
            onClick={handleOTPSubmit}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordOTP;
